import {
  type TypedUseSelectorHook,
  useDispatch,
  useSelector,
} from "react-redux";
import type { RootState, AppDispatch } from "./store";
import type { Api, PrefetchOptions } from "@reduxjs/toolkit/query/react";
import { useLayoutEffect } from "react";

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export interface PrefetchProps<ApiT extends Api<any, any, any, any>> {
  api: ApiT;
  endpoint: string;
  arg?: Parameters<
    ApiT["endpoints"][Extract<keyof ApiT["endpoints"], string>]["initiate"]
  >[0];
  skipCondition?: boolean;
  options?: PrefetchOptions;
}

export function usePrefetchImmediately<ApiT extends Api<any, any, any, any>>(
  items: PrefetchProps<ApiT>[]
) {
  const dispatch = useDispatch<AppDispatch>();
  useLayoutEffect(() => {
    items.forEach(
      ({
        api,
        endpoint,
        arg = undefined,
        options = {},
        skipCondition = false,
      }) => {
        if (skipCondition) return;

        dispatch(api.util.prefetch(endpoint as string, arg as any, options));
      }
    );
  }, []);
}
